import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findTags = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/engineer?` + params,
        method: 'GET'
    })
}
export const findLabelList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/label/select?` + params,
        method: 'GET'
    })
}


export const editTags = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/engineer`,
        method: 'PUT',
        data: params
    })
}
